module.exports = __webpack_public_path__ + "static/img/8.26094de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/eng/8.png
// module id = CG0m
// module chunks = 0